import React from 'react';
import {Link} from 'react-router-dom';
// imgs
import pic1 from '../imgs/1.jpg';

class Signup extends React.Component {
  render() {
    return (
      <div className="container frame">
        <div className="row">
            <div className="col-md-4 offset-md-4 col-sm-6 offset-sm-3">
                <h3>Sign Up</h3>
                <form>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email"/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Password"/>
                        <small id="emailHelp" className="form-text text-muted">8 characters</small>
                    </div>
                    <div className="form-group" style={{display: 'flex'}}>
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </form>
                <br/>
            </div>
        </div>
      </div>
      )
  }
}

export default Signup;